import styled, { css } from 'styled-components';

type ActionButtonProps = {
  isExpanded?: boolean;
};

type MandatoryIndicatorProps = {
  isRequired: boolean;
};

export const Container = styled.div`
  margin-top: 16px;
  width: 100%;
  border-radius: 5px;
  border: 2px solid #e6effb;
  font-family: 'Sora', sans-serif;
  transition: height 0.2s ease-out;
  overflow: hidden;
  background-color: #ffffff;
`;

export const Header = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  justify-content: space-between;
  overflow-x: auto;
  gap: 15px;

  h1 {
    font-size: 16px;
    color: #101d40;
    font-weight: 600;
    letter-spacing: 0px;
    margin-left: -3px;
    white-space: nowrap;
  }

  > div {
    display: flex;
    align-items: center;
    gap: 15px;
  }
`;

export const ActionButton = styled.button<ActionButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34.31px;
  height: 34.31px;
  border-radius: 5px;
  border: 2px solid #e6effb;
  color: #101d40;
  background-color: transparent;

  svg {
    font-size: 23px;
  }

  &.arrow {
    svg {
      transition: all 0.2s ease-in-out;
      transform: ${({ isExpanded }) =>
        isExpanded ? 'rotate(180deg)' : 'rotate(360deg);'};
    }
  }

  & + button {
    margin-left: -10px;
  }
`;

export const Main = styled.main`
  overflow-x: auto;
  overflow-y: hidden;
`;

export const Table = styled.div`
  min-width: max-content;

  hr {
    border: 1px solid #e6effb;
  }
`;

export const TableHeader = styled.div`
  display: grid;
  column-gap: 50px;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 120px;
  padding: 20px 24px;
  font-family: 'Sora', sans-serif;
  font-size: 14px;
  color: #acb3be;
  font-weight: 600;
  align-items: center;
`;

export const TableRow = styled.div`
  display: grid;
  column-gap: 50px;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr 120px;
  border-top: 1px solid #e6effb;
  padding: 15px 24px;
  align-items: center;
  background-color: #ffffff;
`;

export const TableCell = styled.div`
  &:not(:first-child) {
    text-align: center;
  }
`;

export const TableBody = styled.div`
  font-family: 'Sora', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #101d40;
`;

export const ComplementItemDetails = styled.div`
  display: flex;
  align-items: center;

  img {
    margin-right: 18px;
    width: 50px;
    height: 50px;
    border: 2px dashed #e6effb;
    border-radius: 5px;
    object-fit: cover;
  }
`;

export const Imagem = styled.div<{ defaultImg: string; image: string }>`
  background-image: url(${(props) => props.defaultImg});
  display: -webkit-flex;
  align-items: center;
  justify-content: center;

  margin-right: 18px;
  width: 50px;
  min-width: 50px;
  height: 50px;
  border: 2px dashed #e6effb;
  border-radius: 5px;
  background-size: cover;

  div {
    height: 50px;
    width: 100%;

    background-image: url(${(props) => props.image}),
      url(${process.env.REACT_APP_RETAGUARDA_API_FILES}no_image.png);
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
`;

export const MandatoryIndicator = styled.div<MandatoryIndicatorProps>`
  display: inline-block;
  text-transform: uppercase;
  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  padding: 0px 8px;
  border-radius: 4px;

  span {
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    min-height: 24px;
  }

  ${({ isRequired }) =>
    isRequired
      ? css`
          color: rgb(255, 255, 255);
          background-color: rgb(62, 62, 62);
        `
      : css`
          color: rgb(62, 62, 62);
          background-color: rgb(220, 220, 220);
        `}
`;
